import FooterWrapper from '../../components/YodaFooter/HeaderChunksAndFooterLazy';
import HeaderWrapper from '../../components/YodaHeader/Header';
import SignInSliderLazy from '../../components/SignInSlider/SignInSliderConnectLazy';
import FindStoresLazy from '../../components/FindStores/FindStoresLazy';

const components = {
    footer: FooterWrapper,
    header: HeaderWrapper,
    signInSlider: SignInSliderLazy,
    findStoresSlider: FindStoresLazy,
};

export default components;
